import React, { useEffect, useState } from "react";
import { FaCheck, FaFileExcel, FaTimes, FaCaretDown } from "react-icons/fa";
import * as XLSX from "xlsx";
import axios from "axios";
import { API_BASE_URL } from "../../utils/CONSTANTS";
import { toast } from "react-toastify";
import Header from "../../components/header";

const DispatchRegister = () => {
  const [filters, setFilters] = useState({
    startDate: new Date().toISOString().split("T")[0],
    endDate: new Date().toISOString().split("T")[0],
    startDisNo: "",
    endDisNo: "",
  });

  const [data, setData] = useState([]);

  // Sorting state & logic
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const sortedData = React.useMemo(() => {
    if (!data) return [];
    const sortableItems = [...data];

    if (!sortConfig.key) return sortableItems;

    const key = sortConfig.key;
    const dir = sortConfig.direction;

    sortableItems.sort((a, b) => {
      const aVal = a?.[key] ?? "";
      const bVal = b?.[key] ?? "";

      // numeric comparison
      if (!isNaN(Number(aVal)) && !isNaN(Number(bVal))) {
        return dir === "asc" ? Number(aVal) - Number(bVal) : Number(bVal) - Number(aVal);
      }

      // date-like keys
      if (key.toLowerCase().includes("date")) {
        const ta = aVal ? new Date(aVal).getTime() : 0;
        const tb = bVal ? new Date(bVal).getTime() : 0;
        return dir === "asc" ? ta - tb : tb - ta;
      }

      // fallback string compare
      return dir === "asc"
        ? String(aVal).localeCompare(String(bVal))
        : String(bVal).localeCompare(String(aVal));
    });

    return sortableItems;
  }, [data, sortConfig]);

  useEffect(() => {
    handleShow();
  }, [filters]);

  const handleFilterChange = (name, value) => {
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleShow = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/report/dispatchall?startDate=${filters.startDate}&endDate=${filters.endDate}&startVno=${filters.startDisNo}&endVno=${filters.endDisNo}`,
        {
          withCredentials: true,
        }
      );
      // const result = await response.json();
      console.log(response.data.dispatchRecords)
      setData(response.data.dispatchRecords);
    } catch (error) {
      console.error("Error fetching data:", error);
      if (axios.isAxiosError(error)) {
        toast.error(error?.response?.data?.message);
      }
    }
  };

  const handleExport = () => {
    const formattedData = data.map((row) => ({
      "Dispatch V.No.": row.vno,
      Party: row.partyName,
      "Card No.": row.cardNo,
      "Dispatch Qty": row.qty,
      Date: row.Date?.split("T")[0],
      Weight: row.weight,
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dispatch Register");

    XLSX.writeFile(workbook, "DispatchRegister.xlsx");
  };
  return (
    <>
      <Header />

      <div className="p-2 max-w-[1200px] mx-auto">
        <div className="bg-[#e6ffff] border border-gray-300 rounded shadow">
          {/* Header */}
          <div className="flex justify-between items-center px-2 py-1 border-b border-gray-300">
            <h2 className="text-sm font-semibold">Dispatch Register</h2>
            <div className="flex gap-1">
              <button className="p-0.5 hover:bg-gray-200 rounded">
                <FaTimes className="text-gray-600 w-3 h-3" />
              </button>
            </div>
          </div>

          {/* Filters */}
          <div className="grid grid-cols-4 gap-2 p-2 bg-[#e6ffff]">
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-0.5">
                Start Date
              </label>
              <div className="relative">
                <input
                  type="date"
                  value={filters.startDate}
                  onChange={(e) =>
                    handleFilterChange("startDate", e.target.value)
                  }
                  className="w-full border rounded p-1 pr-6 text-xs"
                />
                <FaCaretDown className="absolute right-1.5 top-2 text-gray-400 w-2 h-2" />
              </div>
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 mb-0.5">
                End Date
              </label>
              <div className="relative">
                <input
                  type="date"
                  value={filters.endDate}
                  onChange={(e) => handleFilterChange("endDate", e.target.value)}
                  className="w-full border rounded p-1 pr-6 text-xs"
                />
                <FaCaretDown className="absolute right-1.5 top-2 text-gray-400 w-2 h-2" />
              </div>
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 mb-0.5">
                Start Dis.No.
              </label>
              <input
                type="text"
                value={filters.startDisNo}
                onChange={(e) => handleFilterChange("startDisNo", e.target.value)}
                className="w-full border rounded p-1 text-xs"
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 mb-0.5">
                End Dis.No.
              </label>
              <input
                type="text"
                value={filters.endDisNo}
                onChange={(e) => handleFilterChange("endDisNo", e.target.value)}
                className="w-full border rounded p-1 text-xs"
              />
            </div>
          </div>

          {/* Table */}
          <div className="p-2">
            <div className="border rounded bg-white">
              <table className="w-full text-xs overflow-x-auto">
                <thead>
                  <tr className="border-b">
                    <th
                      onClick={() => handleSort("vno")}
                      className="border-r p-1 text-left font-medium cursor-pointer"
                    >
                      Dis V.No. {sortConfig.key === "vno" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
                    </th>

                    <th
                      onClick={() => handleSort("partyName")}
                      className="border-r p-1 text-left font-medium cursor-pointer"
                    >
                      Party {sortConfig.key === "partyName" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
                    </th>

                    <th
                      onClick={() => handleSort("cardNo")}
                      className="border-r p-1 text-left font-medium cursor-pointer"
                    >
                      Card No. {sortConfig.key === "cardNo" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
                    </th>

                    <th
                      onClick={() => handleSort("qty")}
                      className="border-r p-1 text-left font-medium cursor-pointer"
                    >
                      Dispatch Qty {sortConfig.key === "qty" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
                    </th>

                    <th
                      onClick={() => handleSort("Date")}
                      className="border-r p-1 text-left font-medium cursor-pointer"
                    >
                      Date {sortConfig.key === "Date" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
                    </th>

                    <th
                      onClick={() => handleSort("weight")}
                      className="p-1 text-left font-medium cursor-pointer"
                    >
                      Wt. {sortConfig.key === "weight" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {sortedData.map((row, index) => (
                    <tr key={index} className="border-b">
                      <td className="border-r p-1">{row.vno}</td>
                      <td className="border-r p-1">{row.partyName}</td>
                      <td className="border-r p-1">
                        <a
                          href={`/order-entry?cardNo=${row.cardNo}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 underline hover:text-blue-800"
                        >
                          {row.cardNo}
                        </a>
                      </td>
                      <td className="border-r p-1">{row.qty}</td>
                      <td className="border-r p-1">{row.Date?.split("T")[0]}</td>
                      <td className="p-1">{row.weight}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Footer */}
          <div className="flex justify-between p-2 bg-teal-600">
            <button
              onClick={handleShow}
              className="flex items-center gap-1 bg-white px-3 py-1 rounded hover:bg-gray-50 text-xs">
              <FaCheck className="text-green-600 w-3 h-3" />
              <span>Show</span>
            </button>

            <button
              onClick={handleExport}
              className="flex items-center gap-1 bg-white px-3 py-1 rounded hover:bg-gray-50 text-xs">
              <FaFileExcel className="text-green-600 w-3 h-3" />
              <span>Export to Excel</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DispatchRegister;
